import React from 'react';
import { Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface SupportButtonProps {
  variant?: 'button' | 'link';
  size?: 'small' | 'medium' | 'large';
}

const SUPPORT_PORTAL_URL = 'https://krultra.atlassian.net/servicedesk/customer/portal/1';

export const SupportButton: React.FC<SupportButtonProps> = ({ 
  variant = 'button',
  size = 'medium'
}) => {
  const { t } = useTranslation();

  const openSupportPortal = () => {
    window.open(SUPPORT_PORTAL_URL, '_blank');
  };

  if (variant === 'link') {
    return (
      <Box 
        component="span" 
        onClick={openSupportPortal}
        sx={{ 
          color: 'primary.main', 
          cursor: 'pointer',
          textDecoration: 'underline',
          '&:hover': {
            color: 'primary.dark'
          }
        }}
      >
        {t('support.contactSupport')}
      </Box>
    );
  }

  return (
    <Button
      variant="outlined"
      size={size}
      onClick={openSupportPortal}
      sx={{ ml: 1 }}
    >
      {t('support.title')}
    </Button>
  );
};
